import { render, staticRenderFns } from "./ArchivedCohortImage.vue?vue&type=template&id=3bf62017"
import script from "./ArchivedCohortImage.vue?vue&type=script&lang=js"
export * from "./ArchivedCohortImage.vue?vue&type=script&lang=js"
import style0 from "./ArchivedCohortImage.vue?vue&type=style&index=0&id=3bf62017&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports